<template>
  <avs-card>
    <template v-slot:title>
      <v-card-title class="pl-0">{{ $t("Ajout/Modification User Coupon") }}</v-card-title>
    </template>
    <template v-slot:content>
      <v-container>
        <v-form :readonly="!isEditable" ref="form" v-model="isFormValid">
          <v-text-field
            v-model="coupon.code"
            :disabled="!isEditable"
            :rules="rules.code"
            :label="$t('Code')"
            counter="64"
            maxlength="64"
            outlined
            dense
          ></v-text-field>

          
          
          <v-col class="d-flex justify-end gap-4">
            <avs-saveButton v-if="!loading" @click="save" :disabled="!isEditable || !isFormValid" />
            <avs-button
              v-else
              icon
              color="secondary"
              class="spin-loading"
              :iconI="loading ? 'mdi-loading spin' : ''"
              label
              fab
              small
            />
            <avs-cancelButton @click="cancel" />
          </v-col>
        </v-form>
      </v-container>
    </template>
  </avs-card>
</template>

<script>
import { mkUserCoupon } from "@/utils/datamodels";
import { CouponUsersDetailService, StaffMembersService } from "@/services";
import { required, max64 } from "@/utils/validator";
import _ from "lodash";

export default {
  name: "CouponUserEditor",
  props: {
    hasUniqueName: {
      type: Function,
      required: true,
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
    value: {
      type: Object,
    },
  },
  data() {
    return {
      defaultItems: [],
      couponRequest: mkUserCoupon(),
      loading: false,
      isFormValid: false,
      rules: {
        code: [
          required(this.$t("Le code est obligatoire.")),
          max64(this.$t("Le code ne peut pas dépasser 64 caractères.")),
        ],
      },
      users: [],
    };
  },
  computed: {
    coupon: {
      get() {
        return _.cloneDeep(this.value || this.getDefaultValue());
      },
    },
  },
  created() {
    this.fetchFieldTypes();
  },
  methods: {
    fetchFieldTypes() {
      StaffMembersService.get(this).then((response) => {
        this.users = response.results;
      });
    },
    getDefaultValue() {
      return this.couponRequest;
    },
    cancel() {
      this.$emit("cancel");
    },
    async performSave(data) {
      return data.id > 0
        ? CouponUsersDetailService.put(data)
        : CouponUsersDetailService.post(data);
    },
    handleInputOther() {
      this.$emit("input", this.coupon);
    },
    async save() {
      this.loading = true;

      if (this.$refs.form.validate()) {
        try {
          const response = await this.performSave(this.coupon);
          this.$emit("input", response);
          this.$emit("success", this.$t("Le coupon a été sauvegardé avec succès."));
        } catch (error) {
          const message = error?.response?.data?.detail || this.$t("Une erreur est survenue.");
          this.$emit("error", message);
        } finally {
          this.loading = false;
        }
      } else {
        this.loading = false;
        this.$emit("error", this.$t("Veuillez corriger les erreurs dans le formulaire."));
      }
    },
  },
};
</script>

<style>
.ck.ck-editor__main > .ck-editor__editable {
  height: 200px;
}
.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by {
  display: none !important;
}
.spin-loading {
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
